let downEventName = 'mousedown';
let moveEventName = 'mousemove';
let upEventName = 'mouseup';
if ('ontouchstart' in window) {
  downEventName = 'touchstart';
  moveEventName = 'touchmove';
  upEventName = 'touchend';
}

/**
 * dom元素拖动
 * 在元素上绑定v-drag指令，即可拖动
 */
export default {
  install(Vue) {
    Vue.directive("drag", {
      inserted($el, binding, vnode) {
        function elDown(ev) {
          ev = ev.touches && ev.touches[0] || ev;
          $el.setAttribute('data-flag', false)
          // 用元素距离视窗的X、Y坐标，减去el元素最近的相对定位父元素的left、top值
          let sX = ev.clientX - $el.offsetLeft;
          let sY = ev.clientY - $el.offsetTop;
          const firstTime = new Date().getTime();
          window.addEventListener(moveEventName, rootMove, { passive: false });
          window.addEventListener(upEventName, rootUp, { passive: false });
          function rootMove(ev) {
            ev.preventDefault();
            ev.stopPropagation();
            ev = ev.touches && ev.touches[0] || ev;
            $el.classList.add('drag-active');
            $el.style.left = ev.clientX - sX + 'px';
            $el.style.top = ev.clientY - sY + 'px';
          }
          function rootUp() {
            window.removeEventListener(moveEventName, rootMove, { passive: false });
            window.removeEventListener(upEventName, rootUp, { passive: false });
            const lastTime = new Date().getTime();
            if (lastTime - firstTime < 200) {
              $el.setAttribute('data-flag', true)
            }
            $el.classList.remove('drag-active');
          }
        }
        $el[`on${downEventName}`] = elDown;
      },
      unbind($el) {
        $el[`on${downEventName}`] = null;
      }
    });
  }
};